// @flow

import * as React from 'react';
import { usePaginatedQuery } from '@ta/platform.urql';
import FolloweesQuery from './FolloweesFeed.gql';
import FollowersQuery from './FollowersFeed.gql';

const fetchSize = 20;

type Props = {|
  userId: string,
  isFollowersList: boolean,
  children: (() => Promise<*>, any, boolean, boolean, any, any) => React.Node,
|};

const FollowerFolloweeFeedDataProvider = (props: Props) => {
  const [{ data, fetching, error }, loadMore] = usePaginatedQuery({
    query: props.isFollowersList ? FollowersQuery : FolloweesQuery,
    variables: { userId: props.userId, limit: fetchSize, offset: 0 },
    combineData: (currentData, nextData) => {
      if (!nextData || !currentData.feed.hasMore) return currentData;

      return Object.assign({}, currentData, {
        feed: {
          list: [...currentData.feed.list, ...nextData.feed.list],
          hasMore: nextData.feed.hasMore,
          __typename: currentData.feed.__typename,
        },
      });
    },
    showFetchingAfterFirstQuery: true,
  });

  const updateFeed = () =>
    loadMore({
      offset: data?.feed?.list.length || 0,
    });

  return props.children(
    updateFeed,
    data && data.feed ? data.feed.list : [],
    data && data.feed ? data.feed.hasMore : false,
    fetching,
    error,
    loadMore,
  );
};

export default FollowerFolloweeFeedDataProvider;
